import React from 'react'
import { Link } from 'react-router-dom'
import './github.css'
// import Button from './Button'

export default function OrgStripBox(props) {
    return (
        <div className='org-strip-body'>
            <div className="org-left-content">
                <img src="https://avatars.githubusercontent.com/u/77294337?v=4" alt="org-icon" size="20" height="20" width="20" data-view-component="true" className="avatar avatar-small"/>
                <Link to={props.url}>{props.text}</Link>
                <p>{props.lable}</p>
            </div>
            {/* <div className="org-right-content">
                <Button text={props.buttonText} type={"button"} style={{fontSize: "12px", color: "#cf222e"}} />
            </div> */}
        </div>
    )
}
